module.exports = __webpack_public_path__ + "static/img/1.60014b3.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/culture/1.png
// module id = Ckz9
// module chunks = 1